module.exports = __webpack_public_path__ + "static/media/conveyor-belt-alt.8d0ca5d4.svg";